import {$controller} from "rapid/index";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {forEach} from "lodash";

import {DownloadDialogController} from "../download-dialog/download-dialog";
import DownloadDialogTemplate from "../download-dialog/download-dialog.html";

import {ReportSettingsDialogController} from "../report-settings-dialog/report-settings-dialog";
import ReportSettingsDialogTemplate from "../report-settings-dialog/report-settings-dialog.html";

const dependencies = ["$Forms"];

class AnalyticsDetailController extends $controller {

    constructor($injector, $stateParams, $scope, $document, $timeout) {
        "ngInject";
        super($injector, dependencies);
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.id = this.$stateParams.id;
        this.showDatePicker = false;
        this.loading = false;
        this.showPhotoSystem = false;
        this.showGallery = false;
        this.facebookIcon = require("../../../../images/icons/facebook-old.svg");
        this.twitterIcon = require("../../../../images/icons/twitter.svg");
        this.whatsappIcon = require("../../../../images/icons/whatsapp.svg");
        this.tableIcon = require("../../../../images/icons/table_chart.svg");
        this.tiktokIcon = require("../../../../images/icons/TikTok.svg");
        this.instagramIcon = require("../../../../images/icons/Instagram.svg");

        $document[0].getElementsByTagName("app")[0].onclick = (e) => {
            let a = e.target;
            let isContainer = false;
            let elements = [];
            while (a) {
                elements.unshift(a);
                a = a.parentNode;
            }
            forEach(elements, (el) => {
                if (el.id === "date-container" || el.id === "open-icon") {
                    isContainer = true;
                }
            });
            this.showDatePicker = isContainer;
            this.$scope.$apply(() => this.showDatePicker);
        };
    }

    $onInit() {
        this.loadData(false);
    }

    hideExportMenu() {
        this.$timeout(() => {
            this.showMenu = false;
        }, 300);
    }

    openReportSettings() {
        let parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Settings",
            controller: ReportSettingsDialogController,
            template: ReportSettingsDialogTemplate,
            targetEvent: event,
            locals: {
                callback: (obj) => {
                    this.loading = true;

                    let dataRange = "";
                    if (this.analyticsData && this.analyticsData.date_range) {
                        dataRange = `?start_date=${moment(this.analyticsData.date_range.start_date).utc().format("YYYY-MM-DD HH:mm:SS")}&end_date=${moment(this.analyticsData.date_range.end_date).utc().format("YYYY-MM-DD HH:mm:SS")}`;
                    }
                    this.$auth.$http({
                        url: `/api/analytics/${this.id}${dataRange}`,
                        method: "PUT",
                        data: {report_settings: obj}
                    }).then((resp) => {
                        this.analyticsData = resp.data;
                        this.fillDataForCharts();
                        this.loading = false;
                    });
                },
                reportSettings: this.analyticsData.report_settings
            }
        });
    }

    fillDataForCharts() {
        this.showPhotoSystem = false;
        this.showGallery = false;
        if (this.analyticsData.report_settings.live_gallery) {
            this.secondCharData = [
                {
                    value1: this.analyticsData.report_settings.downloads ? this.analyticsData.live_gallery.total.downloads : false,
                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.downloads : false,
                    label: "Downloads",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.live_gallery.total.downloads ? this.analyticsData.report_settings.downloads : false,
                },
                {
                    value1: this.analyticsData.report_settings.whats_app ? this.analyticsData.live_gallery.total.whats_app : false,
                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.whats_app : false,
                    label: "WhatsApp",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.live_gallery.total.whats_app ? this.analyticsData.report_settings.whats_app : false
                },
                {
                    value1: this.analyticsData.report_settings.facebook ? this.analyticsData.live_gallery.total.facebook : false,
                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.facebook : false,
                    label: "Facebook",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.live_gallery.total.facebook ? this.analyticsData.report_settings.facebook : false
                },
                {
                    value1: this.analyticsData.report_settings.mesenger ? this.analyticsData.live_gallery.total.mesenger : false,
                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.mesenger : false,
                    label: "Messenger",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.live_gallery.total.mesenger ? this.analyticsData.report_settings.mesenger : false
                },
                {
                    value1: this.analyticsData.report_settings.email ? this.analyticsData.live_gallery.total.email : false,
                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.email : false,
                    label: "Email",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                },
                {
                    value1: this.analyticsData.report_settings.twitter ? this.analyticsData.live_gallery.total.twitter : false,
                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.twitter : false,
                    label: "Twitter",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.live_gallery.total.twitter ? this.analyticsData.report_settings.twitter : false
                },
                {
                    value1: this.analyticsData.report_settings.facebook ? this.analyticsData.live_gallery.total.facebook : false,
                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.facebook : false,
                    label: "Facebook",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.live_gallery.total.facebook ? this.analyticsData.report_settings.facebook : false
                },{
                    value1: this.analyticsData.report_settings.instagram ? this.analyticsData.live_gallery.total.instagram : false,
                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.instagram : false,
                    label: "Instagram",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.live_gallery.total.instagram ? this.analyticsData.report_settings.instagram : false
                },
                {
                    value1: this.analyticsData.report_settings.tiktok ? this.analyticsData.live_gallery.total.tiktok : false,
                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.tiktok : false,
                    label: "Tiktok",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.live_gallery.total.tiktok ? this.analyticsData.report_settings.tiktok : false
                }
            ];
        }

        forEach(this.secondCharData,(char) => {
            char.active ? this.showGallery = true : false;
        });

        if (this.analyticsData.report_settings.photo_system) {
            this.firstCharData = [
                {
                    value1: this.analyticsData.photo_system.total.emails,
                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.emails : false,
                    label: "Emails",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.photo_system.total.emails ? this.analyticsData.report_settings.emails : false
                },
                {
                    value1: this.analyticsData.photo_system.total.delivered,
                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.delivered : false,
                    label: "Delivered",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.photo_system.total.delivered ? this.analyticsData.report_settings.delivered : false
                },
                {
                    value1: this.analyticsData.photo_system.total.opens,
                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.opens : false,
                    label: "Opens",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.photo_system.total.opens ? this.analyticsData.report_settings.opens : false
                },
                {
                    value1: this.analyticsData.photo_system.total.clicks,
                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.clicks : false,
                    label: "Clicks",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.photo_system.total.clicks ? this.analyticsData.report_settings.clicks : false
                },
                {
                    value1: this.analyticsData.photo_system.total.messages,
                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.messages : false,
                    label: "SMS",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.photo_system.total.messages ? this.analyticsData.report_settings.messages : false
                },
                {
                    value1: this.analyticsData.photo_system.total.prints,
                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.prints : false,
                    label: "Prints",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.photo_system.total.prints ? this.analyticsData.report_settings.prints : false
                },
                {
                    value1: this.analyticsData.photo_system.total.qr_code_scans,
                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.qr_code_scans : false,
                    label: "QR Code...",
                    color1: "#EE2737",
                    color2: "rgb(241, 145, 163)",
                    active: this.analyticsData.photo_system.total.qr_code_scans ? this.analyticsData.report_settings.qr_code_scans : false
                }
            ];
            forEach(this.firstCharData,(char) => {
                char.active ? this.showPhotoSystem = true : false;
            });
        }
    }

    createPDF() {

        const doc = new jsPDF({format: "a4", orientation: "l"});
        const file = document.getElementById("analytic");
        this.showDatePicker = false;

        html2canvas(file, {
            windowWidth: 1920,
            windowHeight: 1480,
            width: 1920,
            height: 1480,
            scrollX: 0,
            scrollY: 0,
            backgroundColor: "#fafafa",
            scale: 2,
            onclone: (el) => {
                // Change output pdf styles here
                el.getElementById("pdf-logo").style.display = "flex";
                el.getElementById("footer-pdf").style.display = "block";
            }
        }).then((canvas) => {
            const data = canvas.toDataURL();

            doc.addImage(data, "PNG", 0, 0, 300, 0, null, "FAST");
            //doc.setDisplayMode("fullpage");
            doc.save(`${moment(this.analyticsData.date_range.start_date).format("YYYYMMDD")}-${moment(this.analyticsData.date_range.end_date).format("YYYYMMDD")}_${this.analyticsData.company_name}_${this.analyticsData.name}_${moment().format("YYYYMMDD")}.pdf`);
        });
    }

    editData(data) {
        return moment(data).locale("en").format("DD MMM YYYY");
    }

    openPicker() {
        this.showDatePicker = !this.showDatePicker;
    }

    createXLS() {
        let parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Create new configuration",
            controller: DownloadDialogController,
            template: DownloadDialogTemplate,
            targetEvent: event,
            locals: {
                callback: (obj) => {
                    let dataRange = "";
                    if (this.analyticsData && this.analyticsData.date_range) {
                        dataRange = `?start_date=${moment(this.analyticsData.date_range.start_date).utc().format("YYYY-MM-DD HH:mm:SS")}&end_date=${moment(this.analyticsData.date_range.end_date).utc().format("YYYY-MM-DD HH:mm:SS")}`;
                    }
                    let conditionsQuery = `&photo=${obj.captureModes.photo}&gif=${obj.captureModes.gif}&boomerang=${obj.captureModes.boomerang}&dataPrivacyPopupAccepted=${obj.conditions.dataPrivacyPopupAccepted}&consentScreenConfirmed=${obj.conditions.consentScreenConfirmed}&dataFormWasSigned=${obj.conditions.dataFormWasSigned}`;
                    this.$auth.$http({
                        url: `/api/analytics/${this.id}/download${dataRange}${conditionsQuery}`,
                        method: "GET"
                    }).then((resp) => {
                        let link = document.createElement("a");
                        link.href = resp.data.file_url;
                        link.click();
                        link.remove();
                    });
                }
            }
        });

    }

    loadData(reload) {
        let dataRange = "";
        if (reload && this.analyticsData && this.analyticsData.date_range) {
            this.analyticsData.date_range.start_date = this.analyticsData.date_range.start_date || this.minDate;
            this.analyticsData.date_range.end_date = this.analyticsData.date_range.end_date || this.maxDate;
            this.loading = true;
            dataRange = `?start_date=${moment(this.analyticsData.date_range.start_date).utc().format("YYYY-MM-DD HH:mm:SS")}&end_date=${moment(this.analyticsData.date_range.end_date).utc().format("YYYY-MM-DD HH:mm:SS")}`;
        }
        this.$auth.$http({
            url: `/api/analytics/${this.id}${dataRange}`,
            method: "GET"
        }).then((resp) => {
            this.analyticsData = resp.data;
            this.analyticsData.date_range.start_date = this.analyticsData.date_range.start_date ? moment(this.analyticsData.date_range.start_date)._d : null;
            this.analyticsData.date_range.end_date = this.analyticsData.date_range.end_date ? moment(this.analyticsData.date_range.end_date)._d : null;
            if (reload) {
                this.showDatePicker = false;
                this.loading = false;
            } else {
                this.minDate = this.analyticsData.date_range.start_date;
                this.maxDate = this.analyticsData.date_range.end_date;
            }
            if (this.analyticsData.report_settings === null) {
                this.analyticsData.report_settings = {
                    gif: true,
                    email: true,
                    opens: true,
                    photo: true,
                    views: true,
                    clicks: true,
                    emails: true,
                    prints: true,
                    unique: true,
                    twitter: true,
                    instagram: true,
                    tiktok: true,
                    facebook: true,
                    mesenger: true,
                    messages: true,
                    sessions: true,
                    boomerang: true,
                    video: true,
                    delivered: true,
                    downloads: false,
                    whats_app: true,
                    live_gallery: true,
                    photo_system: true,
                    qr_code_scans: true,
                    avg_visit_time: true,
                    show_custom_kpis: false,
                };
            }
            this.fillDataForCharts();
            });
    }
}

export default AnalyticsDetailController;



// WEBPACK FOOTER //
// ./sources/components/analytics/analytics-detail/analytics-detail.controller.js